/* eslint-disable */
import React from 'react';
import cls from 'classnames';
import PropTypes from 'prop-types';

const propTypes = {
	className: PropTypes.string,
};

const defaultProps = {
	className: '',
};

export const IconHand = React.forwardRef(({
	className,
	mobile,
	...props
}, ref) => {
	return (
		<svg
			ref={ref}
			{...props}
			className={cls(className)}
			aria-hidden={true}
			enableBackground='new 0 0 385.3 512'
			viewBox='0 0 385.3 512'
			xmlns='http://www.w3.org/2000/svg'>
			<path
				d='m343.6 201.9h-.7c-9.8-.1-19.3 3.6-26.6 10.1-5.9-16.4-20.9-28.1-38.5-28.1-10.8.1-21.1 4.5-28.6 12.3-6.9-13.9-20.7-23.3-36.5-23.3h-.8c-8.5-.1-16.8 2.6-23.5 7.8v-99.2c0-24-18.7-43.5-41.4-43.5s-41.2 19.5-41.2 43.4l-.2 196.8-11.1-13.5c-9.8-12.2-24.1-19.7-39.7-20.8-15.2-1-30.2 4.3-41.4 14.7l-9.7 8c-3.1 2.6-4 7-2.1 10.6l94.2 181.1c17.2 33.1 50 53.7 85.5 53.7h106.2v-.1c53.8 0 97.5-46.7 97.5-104.1 0-25.7-.1-44.8-.1-60.3.1-41.5 0-56.8-.1-102.5 0-23.8-18.6-43.1-41.2-43.1z'
				fill='#fff'
			/>
			<path
				d='m343.9 201.9h-.7c-9.8-.1-19.3 3.6-26.6 10.1-5.9-16.4-20.9-28.1-38.5-28.1-10.8.1-21.1 4.5-28.6 12.3-6.9-13.9-20.7-23.3-36.5-23.3h-.8c-8.5-.1-16.8 2.6-23.5 7.8v-99.2c0-24-18.7-43.5-41.4-43.5s-41.2 19.5-41.2 43.4l-.2 196.8-11.1-13.5c-9.8-12.1-24.1-19.7-39.7-20.8-15.2-1-30.2 4.3-41.4 14.7l-9.7 8c-3.1 2.6-4 7-2.1 10.6l94.2 181.1c17.2 33.1 50 53.7 85.5 53.7h106.2v-.1c53.8 0 97.5-46.7 97.5-104.1 0-25.7-.1-44.8-.1-60.3.1-41.5 0-56.8-.1-102.5 0-23.8-18.5-43.1-41.2-43.1zm-220.7-120.4c0-14.5 10.9-26.2 24.1-26.2s24.1 11.8 24.1 26.2v133.1 1.4.6 56.9c0 4.8 3.9 8.6 8.6 8.6 4.8 0 8.6-3.9 8.6-8.6v-58.6c0-13.9 10.7-24.9 23.5-24.9h.8c13.2 0 24.2 11.5 24.2 26v52.1c0 4.8 3.9 8.6 8.6 8.6 4.8 0 8.6-3.9 8.6-8.6v-40.9c0-14.5 10.5-26.2 23.7-26.2s23.6 11.8 23.6 26.2v38.6c0 4.8 3.9 8.6 8.6 8.6s8.6-3.9 8.6-8.6v-20.8c0-14.5 11-25.8 24.2-25.8h.7c13.2 0 23.9 11.5 23.9 25.9.1 45.7.1 60.9 0 102.4 0 15.5 0 34.7-.1 60.4 0 47.9-36.2 86.9-80.6 86.9h-105.3c-29.1 0-56-17.1-70.2-44.5l-91-174.9 4.5-3.7c.1-.1.2-.2.3-.3 7.7-7.3 18.1-11 28.7-10.3 10.8.8 20.8 6.1 27.6 14.6l26.4 32.1c2.3 2.8 6.1 3.9 9.6 2.6 3.4-1.2 5.7-4.5 5.7-8.1'
			/>
			<path
				d='m78.8 85.2c4.8 0 8.6-3.9 8.6-8.6.1-32.9 26.8-59.4 59.7-59.4s59.5 26.6 59.7 59.4c0 4.8 3.9 8.6 8.6 8.6 4.8 0 8.6-3.9 8.6-8.6-.2-42.3-34.6-76.6-76.9-76.6-42.4 0-76.8 34.3-76.9 76.6-.1 4.8 3.8 8.6 8.6 8.6z'
			/>
		</svg>
	);
});

IconHand.displayName = 'IconHand';
IconHand.propTypes = propTypes;
IconHand.defaultProps = defaultProps;
export default IconHand;
